import $ from 'jquery';
import * as Sentry from '@sentry/browser';

import TargetingClient from '~/state/Targeting/client';
import CampaignClient from '~/state/Campaign/client';

import { jax } from '~/api/core/legacy';

import { render, querySubscription } from '~/theseus';
import Navbar from '~/theseus/components/Navbar';
import AdPreview from '~/theseus/components/AdPreview';

import analyzeLink from './shared/analyze';
import {
  lb,
  prompt_leave,
  close_lb,
  lb_cust_img,
} from './shared/lightbox';
import { init } from './shared/login';

import {
  publishControls,
  post_ad,
  get_server_url,
} from './components/common';
import { generateMultiPreview, validateAtLeastTwoSearches } from './components/ad-preview';
import getCreatives from './components/getCreatives';

import {
  getSmallImages,
  isSmall,
  addSmallWarning,
  resetSmallWarning,
  isInstagramAd,
} from './lib/instagram';

const LINK_TYPE = 'multi_custom';

let link = null;
const repost_links = [];
let repost = null;
const attachments = [];
const shadow_attachments = [];
let past_main_creatives = [];
let past_sub_creatives = [];
let $sub = null;
const lookup = {};
const override_lookup = { alert_status: { ACTIVE: 'Active', __GRAY__: 'Under Contract', SOLD: 'Sold' } };
let ad_name = '';
let past_templates = 'none';

let account_id = null;
let page_id = null;

querySubscription('account_id', (id) => { account_id = id; });
querySubscription('page_id', (id) => { page_id = id; });

const sub_creative_markup = `
  <div class='creative-item creative-item--custom' style='display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex;'>
    <div class='creative-item__img-col'>
      <div class='creative-item__thumbnail'>
        <img />
      </div>
      <button class='creative-item__cust-img'>Use Custom Image</button>
      <button class='creative-item__clear-cust hide'>Clear Custom Image</button>
    </div>
    <form action='' class='creative-item__edit-creatives'>
      <div class='creative-item__row'>
        <input class='creative-item__first-sub can-add-tags' type='text' placeholder='First Line'>
      </div>
      <div class='creative-item__row'>
        <input class='creative-item__second-sub can-add-tags' type='text' placeholder='Second Line'>
      </div>
    </form>
    <div class='creative-item__options'>
      <button class='creative-item__clear-creative'>Clear Lines</button>
      <button class='creative-item__remove-item'>Remove From Ad</button>
    </div>
  </div>
`;

$('.main-creative__field').on('focus', () => {
  if (past_templates == 'main') { return; }
  past_templates = 'main';
  $('.past-templates__container').hide();
  $('.past-templates__container').empty();
  past_main_creatives.forEach((v) => {
    const $item = $(`<div class='past-templates__item'>${v.markedup}</div>`);
    $('.past-templates__container').append($item);
    $('.past-templates__container').slideDown('fast');
    $item.on('click', () => {
      $('.main-creative__field').val(v.template);
      $('.main-creative__field').focus();
      $('.main-creative__field').trigger('keyup');
    });
  });
});

$('.link__container').on('submit', () => {
  $('.link__add-link').addClass('link__add-link--loading');
  $('.link__input').addClass('link__input--loading');
  link = $.trim($('.link__input').val());
  add_link(link, []);
  return false;
});

let ran = false;
function add_link(search, more_searches) {
  if (!ran) {
    $('.link__add-link').attr('value', 'Add Another Link');
    past_main_creatives = getCreatives({
      type: 'multi_link',
      callback() { past_templates = 'none'; },
    });
    past_sub_creatives = getCreatives({ type: 'multi_link_sub' });
    ran = true;
  }
  let analyze;
  if (repost) { analyze = search.link; } else { analyze = search; }


  analyzeLink(
    'analyze_link_custom',
    LINK_TYPE,
    {
      link: analyze,
    },
    repost?.lead_ad_enabled,
  )
    .then((r) => {
      if (ad_name == '') {
        ad_name = r.name;
      } else {
        ad_name = `${ad_name}, ${r.name}`;
      }
      const trunc = ad_name.length > 200 ? `${ad_name.substring(0, 197)}...` : ad_name;
      CampaignClient.ad.changeName(trunc);

      $('.link__hint').slideDown('fast');
      if (repost) {
        $('.main-creative__field').val(repost.main_creative);
        create_creative(r.link, search.sub_creative.split('///')[0], search.sub_creative.split('///')[1], r.img, [search.img_src]);
      } else {
        create_creative(r.link, r.title[0], r.description[0], r.img, null);
      }
      $('.link__input').val('');
      if (more_searches.length > 0) {
        add_link(more_searches[0], more_searches.splice(1));
      } else {
        TargetingClient.setAsReady();

        $('.main-creative').removeClass('main-creative--disabled');
        $('.image-picker').removeClass('image-picker--disabled');
        $('.button-group').removeClass('button-group--disabled');
        $('.campaign').removeClass('campaign--hidden');
      }
    });
  $('.link__hint').slideUp('fast');
}

function upload_finish(status, hash, url, url_128, state) {
  if (status === 1) {
    close_lb();
    attachments[state].img[0] = url;
    const img = $(`#state_${state}`).attr('src', attachments[state].img[0]);
    img[0].onload = (e) => {
      resetSmallWarning(img);
      if (isSmall(e.target)) {
        addSmallWarning(img);
      }
    };
  } else if (status === 'large') {
    close_lb();
    alert('Image Upload Failed: Image Larger Than 8MB. Try again with a smaller one.');
  } else {
    alert('Image Upload Failed. Try Again');
  }
}

let display_max_prompt = null;
function update_links_amt() {
  clearTimeout(display_max_prompt);
  if (attachments.length == 1) {
    $('.link__amount').html('1 Link Added').slideDown('fast');
  } else if (attachments.length >= 6) {
    $('.link__amount').html(`${attachments.length} Links Added`);
    $('.link__amount').addClass('link__amount--max-reached');
    $('.link__amount').addClass('link__amount--max-disclaimer');
    display_max_prompt = setTimeout(() => {
      $('.link__amount').removeClass('link__amount--max-disclaimer');
    }, 5000);
  } else if (attachments.length == 0) {
    $('.link__amount').slideUp('fast');
  } else {
    $('.link__amount').removeClass('link__amount--max-reached');
    $('.link__amount').removeClass('link__amount--max-disclaimer');
    $('.link__amount').html(`${attachments.length} Links Added`);
  }
}

function create_creative(original_link, title, description, img, cust_img) {
  const $dom = $(sub_creative_markup);
  const $img = $dom.find('img');

  $img[0].onload = (e) => {
    resetSmallWarning($img);
    if (isSmall(e.target)) {
      addSmallWarning($img);
    }
  };

  const pos = shadow_attachments.length;
  let image = null;

  if (cust_img) {
    image = typeof cust_img === 'string' ? cust_img : cust_img[0];
  } else {
    image = typeof img === 'string' ? img : img[0];
  }

  $img.attr('src', image);
  const attachment = {
    original_link,
    title: [title],
    description: [description],
    img: [image],
  };
  attachments.push(attachment);
  shadow_attachments.push(false);
  update_links_amt();
  $img.attr('id', `state_${pos}`);
  $dom.find('.creative-item__first-sub').val(title);
  $dom.find('.creative-item__first-sub').on('keyup', () => {
    attachment.title[0] = $dom.find('.creative-item__first-sub').val();
  });
  $dom.find('.creative-item__second-sub').val(description);
  $dom.find('.creative-item__second-sub').on('keyup', () => {
    attachment.description[0] = $dom.find('.creative-item__second-sub').val();
  });
  $dom.find('.creative-item__clear-cust').on('click', (e) => {
    if (cust_img) {
      attachment.img = cust_img;
    } else {
      attachment.img = img;
    }
    $img.attr('src', attachment.img[0]);
    $(e.target).toggleClass('hide');
    $dom.find('.creative-item__cust-img').toggleClass('hide');
  });
  $dom.find('.creative-item__cust-img').on('click', () => {
    const $img_lb = $(lb_cust_img);
    let c_imgs = [];
    $img_lb.on('click', (e) => {
      if ($(e.target).hasClass('lightbox')) { close_lb(); }
    });
    $img_lb.find('.c-img__file').on('change', function () {
      const send_img = this.files[0];
      const xhr = new XMLHttpRequest();
      const fd = new FormData();
      xhr.open('post', get_server_url('upload_image_new'), true);
      fd.append('account_id', account_id);
      fd.append('state', pos);
      fd.append('image_file', send_img);
      xhr.withCredentials = true;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const r = JSON.parse(xhr.response);
          upload_finish(r.status, r.hash, r.url, r.url_128, r.state);
          $dom.find('.creative-item__cust-img').toggleClass('hide');
          $dom.find('.creative-item__clear-cust').toggleClass('hide');
        } else if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 422) {
          upload_finish('large');
        } else if (xhr.readyState === 4) {
          upload_finish();
        }
      };
      xhr.send(fd);
      $img_lb.find('.c-img__upload-row').addClass('c-img__upload-row--uploading');
    });
    $('body').append($img_lb);
    jax(
      'get_images',
      {
        account_id,
        creative: JSON.stringify({ template: '///' }),
        key_values: JSON.stringify({}),
        lookup: JSON.stringify(lookup),
        override_lookup: JSON.stringify(override_lookup),
      },
      (r) => {
        c_imgs = [];
        r.forEach((e) => {
          c_imgs.push(e);
          const $i = $(`<div class="c-img__item"><img src="${e.url}"/></div>`);
          $i.appendTo('.c-img__image-gallery');
          $i.find('img').on('click', () => {
            attachment.img[0] = e.url;
            $img.attr('src', attachment.img[0]);
            $dom.find('.creative-item__cust-img').toggleClass('hide');
            $dom.find('.creative-item__clear-cust').toggleClass('hide');
            close_lb();
          });
        });
      },
      Sentry.captureException,
    );
    $img_lb.find('.c-img__gallery-toggle').on('click', function () {
      $(this).toggleClass('c-img__gallery-toggle--switch');
      $img_lb.find('.c-img__image-gallery').addClass('c-img__image-gallery--wink');
      $img_lb.find('.c-img__image-gallery--wink').on('transitionend webkitTransitionEnd', () => {
        $img_lb.find('.c-img__image-gallery').toggleClass('c-img__image-gallery--2col')
          .off('transitionend webkitTransitionEnd').toggleClass('c-img__image-gallery--wink');
      });
    });
    $img_lb.find('.lightbox__close').on('click', close_lb);
    return false;
  });
  $dom.find('.can-add-tags').on('focus', () => {
    $sub = $dom;
    if (past_templates == 'sub') {
      return;
    }
    past_templates = 'sub';
    $('.past-templates__container').hide();
    $('.past-templates__container').empty();
    past_sub_creatives.forEach((v) => {
      const markedup = v.markedup.split('///');
      const template = v.template.split('///');
      const $item = $(`<div class='past-templates__item'><div class='past-templates__row'>${markedup[0]}</div><div class='past-templates__row'>${markedup[1]}</div></div>`);
      $('.past-templates__container').append($item);
      $('.past-templates__container').slideDown('fast');
      $item.on('click', () => {
        $sub.find('.creative-item__first-sub').val(template[0]);
        $sub.find('.creative-item__second-sub').val(template[1]);
        $sub.find('.creative-item__first-sub').focus();
      });
    });
  });
  $dom.find('.creative-item__clear-creative').on('click', () => {
    $dom.find('.creative-item__first-sub').val('');
    $dom.find('.creative-item__second-sub').val('');
  });
  $dom.find('.creative-item__remove-item').on('click', () => {
    attachments.splice(pos - shadow_attachments.slice(0, pos).filter(v => v).length, 1);
    shadow_attachments[pos] = true;
    update_links_amt();
    $dom.slideUp('fast', () => { $dom.remove(); });
  });
  $('.image-picker__creatives-container').append($dom);
}

function post_specific_ad() {
  const more_data = {
    attachments: JSON.stringify(attachments),
    main_creative: $('.main-creative__field').val(),
  };
  if (attachments.length <= 1) {
    alert('Please add at least 2 links to your post before creating a carousel');
    return false;
  }

  const smallImages = getSmallImages('variable').all;
  if (smallImages.length !== 0 && isInstagramAd()) {
    lb('Some of your images are too small to post on Instagram. Please try a single or multi-link ad with your own images (at least 500px by 500px), or don\'t run this ad on Instagram.', 'fail', null, null, false, false);
  }

  post_ad('multi_custom', 'multi_custom', more_data, null, account_id, page_id);
  return false;
}

function on_repost(post) {
  repost = post;
  prompt_leave();
  repost.links.forEach((e, i) => {
    repost_links.push({ link: e, sub_creative: repost.sub_creatives[i], img_src: repost.pictures[i] });
  });
  add_link(repost_links[0], repost_links.splice(1));
  $('.main-creative__field').val(repost.main_creative).keyup();
}

function createPreview(previewType) {
  return generateMultiPreview(
    page_id,
    account_id,
    $('.main-creative__field').val(),
    attachments,
    [],
    $('#check-end-card').prop('checked'),
    previewType,
  );
}

function load_data() {
  publishControls('#publish_container', post_specific_ad, LINK_TYPE);
  render('#ad-preview', <AdPreview getPreview={createPreview} validation={validateAtLeastTwoSearches(() => attachments)} />);
}

init(on_repost)
  .then(load_data);
